var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("speeches.persons.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "funeral-oration-form-group",
                            label: _vm.$t("speeches.persons.burialSpeaker"),
                            "label-for": "funeral-oration-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "funeral-oration-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "speeches.persons.placeholder"
                              )
                            },
                            model: {
                              value: _vm.localBurialSpeaker,
                              callback: function($$v) {
                                _vm.localBurialSpeaker = $$v
                              },
                              expression: "localBurialSpeaker"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "foreword-form-group",
                            label: _vm.$t("speeches.persons.ceremonySpeaker"),
                            "label-for": "foreword-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "foreword-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "speeches.persons.placeholder"
                              )
                            },
                            model: {
                              value: _vm.localCeremonySpeaker,
                              callback: function($$v) {
                                _vm.localCeremonySpeaker = $$v
                              },
                              expression: "localCeremonySpeaker"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col button-div" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "save-button o-button",
                          on: { click: _vm.save }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("speeches.persons.saveButton")) +
                              "\n                            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-6" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("speeches.documents.title") }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-content" },
                [
                  _c("file-upload-component", {
                    attrs: {
                      category: _vm.deathNoticeType,
                      title: _vm.titles.SPEECHES_TYPE_DEATH_NOTICE
                    }
                  }),
                  _vm._v(" "),
                  _c("file-upload-component", {
                    attrs: {
                      category: _vm.burialSpeechType,
                      title: _vm.titles.SPEECHES_TYPE_BURIAL_SPEECH
                    }
                  }),
                  _vm._v(" "),
                  _c("file-upload-component", {
                    attrs: {
                      category: _vm.ceremonySpeechType,
                      title: _vm.titles.SPEECHES_TYPE_CEREMONY_SPEECH
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-213aa2d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-213aa2d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/SpeechesComponent.vue
// module id = null
// module chunks = 